import { KeyboardArrowDown } from '@mui/icons-material'
import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

type ViewOlderMentionsProps = {
  onClick: () => void
}

export const ViewOlderMentions = ({ onClick }: ViewOlderMentionsProps) => {
  const { t } = useTranslation('dashboard')
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick()
        }
      }}
      sx={{ py: 2, cursor: 'pointer' }}
    >
      <Typography variant="small-regular" color="text.muted">
        {t('mentions.view-older')}
      </Typography>
      <KeyboardArrowDown sx={{ color: 'fg.muted', fontSize: 16 }} />
    </Stack>
  )
}
